import React, { useMemo } from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { useWorkspacesList } from "@api/workspace.api";
import { useScope } from "@state/scopeContext.lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

interface Props {
    name: string;
    clientIds: string[] | undefined;
    onClientIdsChange: (clientIds: string[] | undefined) => void;
}

/** Multi-select of the organization's clients (workspaces). */
export const ClientMultiselect: React.FC<Props> = ({
    name,
    clientIds,
    onClientIdsChange,
}) => {
    const { organizationId } = useScope();
    const { data: clients = [] } = useWorkspacesList(
        organizationId ? { organizationId } : undefined,
        { enabled: !!organizationId },
    );

    const options = useMemo<FilterMultiselectOption[]>(
        () =>
            clients.map((client) => ({
                value: client.id,
                label: client.name,
                searchableLabel: client.name,
            })),
        [clients],
    );

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                options={options}
                value={clientIds ?? []}
                onChange={(val) => {
                    const selected = val.map(String);
                    onClientIdsChange(selected.length ? selected : undefined);
                }}
                name={name}
                onBlur={noop}
            />
        </div>
    );
};
